"use client";

import React from "react";
import { Download, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExpressionOfInterestAssetWarehouseCarparkProtection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="expression-of-interest-asset-warehouse-carpark-protection" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="overflow-hidden border-border shadow-md">
            <CardContent className="p-0">
              <div className="flex flex-col md:flex-row items-center justify-between p-8 md:p-10 gap-8">
                <div className="flex flex-col md:flex-row items-center md:items-start gap-6 text-center md:text-left">
                  <div className="bg-primary/10 p-4 rounded-lg shrink-0">
                    <FileText className="size-10 text-primary" />
                  </div>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/industrial_protection_specifications_layout.png" alt="Asset, Warehouse and Carpark Protection" className="h-24 md:h-32 w-auto object-contain shrink-0" />
                  <div className="space-y-2">
                    <h2 className="text-2xl md:text-3xl font-default font-bold text-foreground">
                      Expression of Interest
                    </h2>
                    <h3 className="text-primary font-mono text-sm md:text-base font-semibold uppercase tracking-wider">
                      Carpark, Warehouse & Asset Protection
                    </h3>
                    <p className="text-muted-foreground text-base md:text-lg max-w-xl">
                      Download the comprehensive documentation covering asset, warehouse, and carpark protection requirements and specifications.
                    </p>
                  </div>
                </div>
                <div className="shrink-0 w-full md:w-auto">
                  <Button size="lg" className="w-full md:w-auto gap-2 text-base h-14 px-8 rounded-lg shadow-sm" asChild>
                    <Link to="https://bottomupprojects.com.au/wp-content/uploads/2026/10/EOI-SUPPLY-INSTALL-Asset-Warehouse-Carpark-Protection.pdf" newTab>
                      <Download className="size-5" />
                      <span>Download EOI</span>
                      <span className="text-[10px] font-mono opacity-70 uppercase tracking-wider">
                        PDF size: 2.3 MB
                      </span>
                    </Link>
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}